import { postApi } from '@/api';
export default {
  name: 'cascadeOfCity',
  model: {
    prop: 'selected',
    // 默认prop为value，model选项可以指定自定义prop
    event: 'select' // model默认绑定事件为input，model选项可以指定自定义event

  },
  props: {
    addressList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isDisableAddr: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showDeep: {
      type: Number,
      default: 999
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: '请选择地址',
    id: '',
    isClear: false,
    time: {
      // 延迟加载时间
      required: false,
      default: 200
    }
  },
  watch: {
    currValue: function currValue(val) {
      if (!val.length) {
        this.$emit('on-change', '');
      }
    },
    selected: function selected(val) {
      var _this = this;

      this.currValue = val;
      setTimeout(function () {
        _this.isDisable = _this.isDisableAddr;
      }, 1000);
    }
  },
  created: function created() {
    // this.init(this.currValue);
    // setTimeout(() => {
    // 	// 延迟加载
    // 	this.initAddressData()
    // }, Number(this.time || 0))
    this.initSlot();
  },
  data: function data() {
    return {
      isDisable: this.isDisableAddr,
      currValue: this.selected,
      provinceData: [],
      cityData: [],
      areaData: [],
      townData: [],
      addressJson: [],
      initSuccess: false
    };
  },
  methods: {
    change: function change(value, selectedData) {
      var labels = [];

      _.each(selectedData, function (item, i) {
        labels.push(item.label);
      });

      this.currValue = value;
      this.$emit('select', value);
      this.$emit('on-change', {
        value: value,
        selectedData: selectedData,
        labels: labels
      });
    },
    changeVisible: function changeVisible(val) {
      this.isDisable = val; // setTimeout(() => {
      //   this.isDisable = false;
      // }, 100000);
    },
    initSlot: function initSlot() {
      var vm = this;
      setTimeout(function () {
        vm.initSuccess = true;
      }, Number(vm.time || 0));
    },
    loadData: function loadData(item, callback) {
      item.loading = true;

      if (item.provinceCode) {
        _.forEach(this.cityData, function (i) {
          if (item.provinceCode == i.parentCode) {
            item.children.push(i);
          }
        });

        item.loading = false;
        callback();
      }
    },
    initAddressData: function initAddressData() {
      var data = JSON.parse(localStorage.getItem('addressJson'));
      var provinceData = [];
      var cityData = [];

      _.forEach(data, function (item) {
        var obj = {};

        _.assign(obj, _.pick(item, ['provinceCode', 'provinceName']), {
          children: [],
          loading: false,
          label: item.provinceName,
          value: item.provinceCode
        });

        provinceData.push(obj);

        _.forEach(item.children, function (sItem) {
          var obj = {};

          _.assign(obj, _.pick(sItem, ['cityCode', 'cityName']), {
            children: [],
            parentCode: item.provinceCode,
            parentName: item.provinceName,
            label: sItem.cityName,
            value: sItem.cityCode
          });

          cityData.push(obj);
        });
      });

      var obj = {};
      provinceData.forEach(function (item) {
        obj[item.provinceCode] = item;
      });
      cityData.forEach(function (item) {
        if (obj[item.parentCode]) {
          obj[item.parentCode].children.push(item);
        }
      });
      this.provinceData = provinceData;
    }
  }
};